import { IGatsbyImageData } from "gatsby-plugin-image";

export function isGatsbyImageData(obj: any): obj is IGatsbyImageData {
    return (
        obj &&
        obj.layout &&
        typeof obj.width === "number" &&
        typeof obj.height === "number"
    );
}
